import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const featuredProjects = [
    {
      title: "AI Resume Analyzer",
      description:
        "RAG-powered resume and job-description matching system",
      imgUrl:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://ai-resume-analyser-eta-five.vercel.app/",
      technologies: [
        "React.js",
        "Node.js",
        "RAG",
        "ChromaDB",
        "Gemini",
        "Docker",
      ],
    },
    {
      title: "StackAdvance",
      description:
        "Stack Overflow-style Q&A platform with authentication",
      imgUrl:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://stack-overflow-main-app.vercel.app/",
      technologies: [
        "React.js",
        "Node.js",
        "Express.js",
        "MongoDB",
        "OAuth",
      ],
    },
    {
      title: "India Tourism Bot",
      description:
        "Travel assistance chatbot with API integration",
      imgUrl:
        "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://t.me/Travel150Bot",
      technologies: [
        "Python",
        "Chatbot",
        "API",
        "Dialogflow",
      ],
    },
    {
      title: "YouTube Clone",
      description:
        "Frontend implementation of a YouTube-style video platform",
      imgUrl:
        "https://images.unsplash.com/photo-1540655037529-dec987208707?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://github.com/HarshAgria/Youtube-Clone",
      technologies: [
        "React.js",
        "JavaScript",
        "HTML",
        "CSS",
      ],
    },
    {
      title: "Internet Speed Tracker",
      description:
        "Application for measuring and tracking internet speed",
      imgUrl:
        "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=900&q=80",
      projecturl:
        "https://github.com/HarshAgria/Internet-Speed_tester",
      technologies: [
        "Python",
        "Networking",
        "Automation",
      ],
    },
    {
      title: "File Encrypt & Decrypt",
      description:
        "Python-based utility for secure file encryption and decryption",
      imgUrl:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=900&q=80",
      projecturl:
        "https://github.com/HarshAgria/File_Encrypt-and_Decrypter",
      technologies: [
        "Python",
        "Cryptography",
        "Security",
      ],
    },
  ];

  const developmentProjects = [
    {
      title: "GoGoMaps",
      description:
        "Android-based maps and location application",
      imgUrl:
        "https://images.unsplash.com/photo-1524666041070-9e5c7f3c3a5c?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://github.com/HarshAgria/GoGoMaps",
      technologies: [
        "Java",
        "Android",
        "Maps API",
      ],
    },
    {
      title: "MyCalci",
      description:
        "Android calculator application",
      imgUrl:
        "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://github.com/HarshAgria/MyCalci",
      technologies: [
        "Java",
        "Android",
      ],
    },
    {
      title: "My ChatBot",
      description:
        "Conversational chatbot application with API integration",
      imgUrl:
        "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://github.com/HarshAgria/MyBot",
      technologies: [
        "Android",
        "API",
        "Dialogflow",
      ],
    },
    {
      title: "Weather App",
      description:
        "Weather application consuming external weather APIs",
      imgUrl:
        "https://images.unsplash.com/photo-1534088568595-a066f410bcda?auto=format&fit=crop&w=900&q=80",
      projecturl:
        "https://github.com/HarshAgria/-Weather_App-Python-",
      technologies: [
        "Python",
        "API",
      ],
    },
    {
      title: "Phone Number Tracker",
      description:
        "Python utility for phone number information and location data",
      imgUrl:
        "https://images.unsplash.com/photo-1516321165247-4aa89a48be28?auto=format&fit=crop&w=900&q=80",
      projecturl:
        "https://github.com/HarshAgria/Phone-Number_location-tracker",
      technologies: [
        "Python",
        "APIs",
      ],
    },
    {
      title: "Age & Gender Prediction",
      description:
        "Computer vision application for age and gender prediction",
      imgUrl:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://github.com/HarshAgria/Age-and-Gender-Prediction-App",
      technologies: [
        "Java",
        "Computer Vision",
        "Android",
      ],
    },
  ];

  const utilityProjects = [
    {
      title: "PDF Merger",
      description:
        "Python utility for merging multiple PDF documents",
      imgUrl:
        "https://images.unsplash.com/photo-1554224154-26032ffc0d07?auto=format&fit=crop&w=900&q=80",
      projecturl: "https://github.com/HarshAgria/PDF_merger",
      technologies: [
        "Python",
        "PDF",
      ],
    },
    {
      title: "QR Code Generator",
      description:
        "Python-based QR code generation utility",
      imgUrl:
        "https://images.unsplash.com/photo-1595079676339-1534801ad6cf?auto=format&fit=crop&w=900&q=80",
      projecturl:
        "https://github.com/HarshAgria/QR-Code-Generator",
      technologies: [
        "Python",
      ],
    },
    {
      title: "RoboSpeaker",
      description:
        "Text-to-speech application built with Python",
      imgUrl:
        "https://images.unsplash.com/photo-1589254065878-42c9da997008?auto=format&fit=crop&w=900&q=80",
      projecturl:
        "https://github.com/HarshAgria/RoboSpeaker_Text_to_Speech",
      technologies: [
        "Python",
        "Text-to-Speech",
      ],
    },
  ];

  const renderProjects = (projects) => (
    <Row>
      {projects.map((project, index) => (
        <ProjectCard
          key={index}
          {...project}
        />
      ))}
    </Row>
  );

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible
                      ? "animate__animated animate__slideInUp"
                      : ""
                  }
                >
                  <h2>Projects</h2>

                  <p>
                    A collection of projects spanning full-stack
                    development, AI systems, Android applications,
                    automation, and software utilities.
                  </p>
                </div>
              )}
            </TrackVisibility>

            <Tab.Container
              id="projects-tabs"
              defaultActiveKey="featured"
            >
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center align-items-center"
                id="pills-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="featured">
                    Featured
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="development">
                    Development
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="utilities">
                    Utilities
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="featured">
                  {renderProjects(featuredProjects)}
                </Tab.Pane>

                <Tab.Pane eventKey="development">
                  {renderProjects(developmentProjects)}
                </Tab.Pane>

                <Tab.Pane eventKey="utilities">
                  {renderProjects(utilityProjects)}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>

      <img
        className="background-image-right"
        src={colorSharp2}
        alt=""
      />
    </section>
  );
};
